/* eslint-disable react/no-array-index-key */
import React from 'react';
import moment from 'moment';
import { Row, Col, Card, CardBody, Table } from 'reactstrap';

import { StatusVenda } from '~/components/Status';
import { Cartoes } from '~/components/Cartoes';
import { LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';

import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';
import { TrStyled } from '../styles';

export function TransacoesGrupo({ transacoes }) {
	function retornaModalidade(cell, row) {
		if (row.parcelas > 1) {
			return `Parcelado em ${row.parcelas}x`;
		}
		if (cell === 'crédito à vista') {
			return `Crédito à vista`;
		}
		if (cell === 'débito') {
			return `Débito`;
		}
		return cell;
	}
	return (
		<Table id="test-table-xls-button" responsive className="notranslate">
			<thead>
				<TrStyled>
					<th>Id</th>
					<th>Data</th>
					<th>Valor</th>
					<th>Titular</th>
					<th>Bandeira</th>
					<th>Modalidade</th>
					<th>Status</th>
				</TrStyled>
			</thead>
			<tbody>
				{transacoes &&
					transacoes.map((item, index) => (
						<tr key={`${item.autorizacao}-${index}`}>
							<td>{item.autorizacao}</td>
							<td>
								{moment.utc(item.data_transacao).format(
									'DD/MM/YYYY'
								)}
							</td>
							<td>
								{symbolPriceFormatter(item.valor_transacao)}
							</td>
							{item.nome.length > 16 ? (
								<td title={item.nome}>
									{`${item.nome.substr(0, 16)}...`}
								</td>
							) : (
								<td>{item.nome}</td>
							)}
							<td>
								{item.bandeira &&
									<Cartoes cartao={item.bandeira.toLowerCase()} />
								}
							</td>
							<td>{retornaModalidade(item.modalidade, item)}</td>
							<td>
								<StatusVenda status={item.status} />
							</td>
						</tr>
					))}
			</tbody>
		</Table>
	);
}

export function CardGrupo({ loadingTransactions, totalGrupos }) {
	const dadosGrupo = [
		{
			nome: 'Total de vendas',
			nome_index: 'total_vendas',
			color: 'white',
			bg_color: color.softBlack,
		},
		{
			nome: 'Débito',
			nome_index: 'total_debito',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Crédito à vista',
			nome_index: 'total_credito',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Parcelado 2 a 6 vezes',
			nome_index: 'total_parcelado2a6',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Parcelado 7 a 12 vezes',
			nome_index: 'total_parcelado7a12',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Parcelado 13 a 18 vezes',
			nome_index: 'total_parcelado13a18',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Parcelado 19 a 24 vezes',
			nome_index: 'total_parcelado19a24',
			color: 'gray',
			bg_color: color.yellow,
		},
	];

	return (
		<Row className="mt-5">
			{dadosGrupo.map((item) => (
				<Col key={`${item.nome_index}-${item.nome}`}>
					<Text>{item.nome}</Text>
					<Card
						style={{
							backgroundColor: item.bg_color,
							borderRadius: '0px 10px 10px 10px',
						}}>
						<CardBody className="py-4 px-2">
							{loadingTransactions ? (
								<div className="d-flex justify-content-center">
									<LoaderMini />
								</div>
							) : (
								<Text color={item.color} size="big" center>
									{symbolPriceFormatter(
										totalGrupos[item.nome_index]
									)}
								</Text>
							)}
						</CardBody>
					</Card>
				</Col>
			))}
		</Row>
	);
}
